// src/utils/audio.js
class AudioPlayer {
    constructor() {
      this.audio = new Audio();
      this.isPlay = false
    }
  
    play(url) {
      if(this.isPlay)return;

      this.audio.src = url;
      this.isPlay = true
      this.audio.play().catch(error => {
        console.error('播放失败:', error);
        // 处理浏览器自动播放策略：需用户交互后触发
      }).finally(()=>{
        this.isPlay = false
      })
    }
  
    pause() {
      this.audio.pause();
    }

    playTick(){
        this.play(require('@/assets/MP3.mp3'))
    }

  }
  
  export const audioPlayer = new AudioPlayer();